import { render, staticRenderFns } from "./HoldReasonsReview.vue?vue&type=template&id=aa9a80de&scoped=true&"
import script from "./HoldReasonsReview.vue?vue&type=script&lang=js&"
export * from "./HoldReasonsReview.vue?vue&type=script&lang=js&"
import style0 from "./HoldReasonsReview.vue?vue&type=style&index=0&id=aa9a80de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa9a80de",
  null
  
)

export default component.exports